import { mapProps } from 'recompose';
import ResourceCardComponent from './components/ResourceCardComponent';

var propsMapper = function propsMapper(props) {
  return Object.assign({}, props.resource, props);
};

var ResourceCard = mapProps(propsMapper)(ResourceCardComponent);
export default ResourceCard;